import {
	Badge,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	SwipeableDrawer,
	WithStyles,
} from '@material-ui/core';
import pink from '@material-ui/core/colors/pink';
import { ListItemTextProps } from '@material-ui/core/ListItemText/ListItemText';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import ELTestFormIcon from 'src/icons/ELTestFormIcon';
import ELTextIcon from 'src/icons/ELTextIcon';
import * as Actions from '../actions/quickModeContens';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
const styles = (theme: Theme) =>
	createStyles({
		descriptionCss: {
			backgroundColor: pink[200],
			fontFamily: 'Helvetica, sans-serif',
			fontWeight: 'bold',
			height: '16px',
			left: '-19px',
			marginLeft: '12px',
			top: 10,
			width: '16px',
		},
		descriptionWidth: {
			width: '150px',
		},
		required: {
			backgroundColor: pink[200],
			fontFamily: 'Helvetica, sans-serif',
			fontWeight: 'bold',
			height: '16px',
			right: 5,
			width: '16px',
		},
		timePadding: {
			paddingBottom: '0px',
			paddingTop: '0px',
		},
	});

class QuickModeIndexTree extends React.Component<IProps> {
	constructor(props: IProps) {
		super(props);
	}
	public render() {
		return (
			<>
				<SwipeableDrawer
					open={this.props.open}
					onOpen={this.props.openIndexTree}
					onClose={this.props.openIndexTree}
				>
					<List component="nav" disablePadding={true}>
						<ListItem>
							<ListItemText
								key={`title`}
								primary={i18n.t('QuickModeIndexTree_0000')}
							/>
						</ListItem>
					</List>
					<this.ContentsItem />
					<this.Description />
				</SwipeableDrawer>
			</>
		);
	}

	public setCurrentItem = (kind: string, page: number) => () => {
		this.props.setCurrentItem(kind, page);
		this.props.openIndexTree();
	};

	protected ContentsItem: React.SFC = props => {
		let isCurrent = '';
		if (this.props.currentItem) {
			isCurrent = this.props.currentItem.kind;
		}
		const listItemTextProps: ListItemTextProps = {
			primary: 'テキストグループ',
		};
		const listItemTestProps: ListItemTextProps = {
			primary: 'テスト',
		};
		if (isCurrent === 'TEXT') {
			listItemTextProps.primaryTypographyProps = {
				color: 'primary',
			};
		}
		if (isCurrent === 'TEST') {
			listItemTestProps.primaryTypographyProps = {
				color: 'primary',
			};
		}
		const { test, text } = this.props;
		return (
			<List component="nav" disablePadding={true}>
				{text.length > 0 && (
					<ListItem
						button={true}
						onClick={this.setCurrentItem('TEXT', 0)}
					>
						<Badge
							color="error"
							badgeContent="!"
							classes={{ badge: this.props.classes.required }}
						>
							<ListItemIcon>
								<ELTextIcon />
							</ListItemIcon>
						</Badge>
						<ListItemText key={`text`} {...listItemTextProps} />
					</ListItem>
				)}
				{test && (
					<ListItem
						button={true}
						onClick={this.setCurrentItem('TEST', 0)}
					>
						<Badge
							color="error"
							badgeContent="!"
							classes={{ badge: this.props.classes.required }}
						>
							<ListItemIcon>
								<ELTestFormIcon />
							</ListItemIcon>
						</Badge>
						<ListItemText key={`text`} {...listItemTestProps} />
					</ListItem>
				)}
			</List>
		);
	};

	protected Description: React.SFC = props => {
		return (
			<List component="nav" disablePadding={true}>
				<ListItem
					className={this.props.classes.timePadding}
					style={{ marginTop: '50px' }}
				>
					<ListItemIcon
						className={this.props.classes.descriptionWidth}
					>
						<Badge
							color="error"
							badgeContent="!"
							classes={{
								badge: this.props.classes.descriptionCss,
							}}
						>
							<span style={{ marginLeft: '22px' }}>
								{i18n.t('QuickModeIndexTree_0001')}
							</span>
						</Badge>
					</ListItemIcon>
				</ListItem>
				<ListItem
					className={this.props.classes.timePadding}
					style={{ marginTop: '20px' }}
				>
					<ListItemIcon
						className={this.props.classes.descriptionWidth}
					>
						<>
							<ELTextIcon />
							<span
								style={{ marginLeft: '10px', marginTop: '3px' }}
							>
								{i18n.t('QuickModeIndexTree_0002')}
							</span>
						</>
					</ListItemIcon>
					<ListItemIcon
						className={this.props.classes.descriptionWidth}
					>
						<>
							<ELTestFormIcon />
							<span
								style={{ marginLeft: '10px', marginTop: '3px' }}
							>
								{i18n.t('QuickModeIndexTree_0003')}
							</span>
						</>
					</ListItemIcon>
				</ListItem>
			</List>
		);
	};
}

const mapStateToProps = (state: IRootState) => ({
	currentItem: state.quickModeContents.currentItem,
	open: state.quickModeContents.indexTreeOpen,
	test: state.quickModeContents.test,
	text: state.quickModeContents.text,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	openIndexTree: () => {
		dispatch(Actions.setIndexTree({}));
	},
	setCurrentItem: (kind: string, page: number) => {
		dispatch(Actions.setCurrentItem({ kind, page }));
	},
});

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles>;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(QuickModeIndexTree);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/QuickModeIndexTree.tsx